"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = void 0;
exports.toasts = toasts;
var actions = _interopRequireWildcard(require("../actions"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const initialState = exports.initialState = {
  entities: []
};
function toasts(state = initialState, action) {
  switch (action.type) {
    case actions.SHOW_TOAST:
      return {
        ...state,
        entities: [action.payload, ...state.entities]
      };
    case actions.CLEAR_TOAST:
      return {
        ...state,
        entities: state.entities.filter(entity => entity.id !== action.payload.id)
      };
    default:
      return state;
  }
}